import { buildHeaders } from "../apis/api.client";

export const getBase64ImageFromUrl = async (imageUrl: any) => {
    const res = await fetch(imageUrl, { headers: buildHeaders() });
    const blob = await res.blob();
    return new Promise((resolve, reject) => {
      const reader  = new FileReader();
      reader.addEventListener("load", function () {
          resolve(reader.result);
      }, false);
      reader.onerror = () => {
        return reject(this);
      };
      reader.readAsDataURL(blob);
    });
};

export const getAzureResource = async (imageUrl: any) => {
  if(imageUrl) {
      const res = await fetch(imageUrl, { headers: buildHeaders() });
      const blob = await res.blob();
      const url = await URL.createObjectURL(blob);
      return url;
  } else {
    return "";
  }
};